import React from 'react'
import SAISVG from '../../../../../_template/helpers/CommonFunction'
import { PageTitle } from "../../../../../_template/layout/core/PageData";
const BusinessSetup = () => {
    const businessSetupTitle = [
        {
            title: 'settings',
            path: '/admin/settings/product-setup',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];
    return (
        <>
            <PageTitle breadcrumbs={businessSetupTitle}>Business Setup</PageTitle>
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12 mb-5">
                            <div className="card card-flush h-md-100 bg-gray-400">
                                <div className="card-body pb-5">
                                    <div className="d-flex flex-wrap flex-sm-nowrap">
                                        <div className="me-7 mb-4">
                                            <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative bg-light">
                                                {/* <img src="https://mysai.thesai.co.in/assets/system/sai-logo.svg" alt="image" /> */}
                                                <img src="/media/avatars/300-1.jpg" alt="image" />
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                                <div className="row w-100">
                                                    <div className="col-md-10">
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center">
                                                                <a href="javascript:;" className="text-primary fs-2 fw-bold me-1 text-uppercase">
                                                                    Lipozene
                                                                </a>
                                                                <a href="javascript:;">
                                                                    <i className="ki-outline ki-verify fs-1 text-success"></i>
                                                                </a>
                                                            </div>
                                                            <div className="d-flex flex-wrap fw-semibold fs-5 text-gray-600">
                                                                Business id is 
                                                                <span className="text-primary mx-2">
                                                                    8905071491
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <span className="badge me-auto badge-light-dark">
                                                                    noreply@lipozene.com
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 text-end p-0">
                                                        <a href="#" className="btn btn-light btn-icon btn-sm">
                                                            <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex flex-wrap flex-stack">
                                                <div className="row w-100">
                                                    <div className="col-md-6">
                                                        <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 h-md-100">
                                                            <div className="d-flex flex-stack m-d-block">
                                                                <div className="">
                                                                    <div className="fw-bold fs-7 text-gray-600">
                                                                        Business Address
                                                                    </div>
                                                                    <div className="d-flex align-items-center m-d-block">
                                                                        <div className="fs-7 text-light">
                                                                            No 30, J L Nehru Road, Park Street, Kolkata
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 pe-0">
                                                        <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 h-md-100">
                                                            <div className="d-flex flex-stack">
                                                                <div className="fw-bold fs-7 text-gray-600">
                                                                    Primary Contact
                                                                </div>
                                                                <div className="d-flex align-items-senter">
                                                                    <span className="text-light">
                                                                        18602331234
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="separator separator-dashed my-3"></div>
                                                            <div className="d-flex flex-stack">
                                                                <div className="fw-bold fs-7 text-gray-600">
                                                                    Secondary Contact
                                                                </div>
                                                                <div className="d-flex align-items-senter">
                                                                    <span className="text-light">
                                                                    18602331234
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-5">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="notice d-flex bg-light-success rounded border-success border border-dashed mb-12 p-6">
                                <i className="ki-duotone ki-shield-tick fs-3tx text-success me-4">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                                <div className="d-flex flex-stack flex-grow-1">
                                    <div className="fw-semibold">
                                        <h4 className="text-success fw-bold">
                                            License active for Premium plan
                                        </h4>
                                        <div className="fs-6 text-success">
                                            Your license key AGI4155640585 is active from 20 Sep, 2024 to 19 Sep, 2025
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-7">
                                    <h3 className="mb-2">
                                        Subscription valid till 19 Sep, 2025
                                    </h3>
                                    <p className="fs-6 text-gray-600 fw-semibold mb-6 mb-lg-15">
                                        We will send you a notification upon Subscription expiration
                                    </p>
                                </div>
                                <div className="col-lg-5">
                                    <div className="d-flex text-muted fw-bold fs-5 mb-3">
                                        <span className="flex-grow-1 text-gray-800">Days utilized</span>
                                        <span className="text-gray-800">68 of 364</span>
                                    </div>
                                    <div className="progress h-8px bg-light-primary mb-2">
                                        <div className="progress-bar bg-primary" role="progressbar" style={{width :"19%"}} aria-valuenow="86" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <div className="fs-6 text-gray-600 fw-semibold mb-10">
                                        296 days are remaining to expire your Subscription
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-5">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header bg-primary">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-white fs-1">Active Services</span>
                                <span className="text-white mt-1 fw-semibold fs-6">You have <span className="cnt-active-plan">3</span> active services</span>
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="row gx-9 gy-6">
                                <div className="col-xl-6">
                                    <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap bg-light-primary border-primary">
                                        <div className="card-body p-6">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="d-flex flex-column py-2">
                                                        <div className="d-flex align-items-center text-primary fs-2x fw-bold">
                                                            Analytics
                                                        </div>
                                                        <div className="fw-bold">
                                                            <span className="fs-2 d-block mt-6 text-primary">
                                                                Historical Data Insight
                                                            </span>
                                                            <span className="opacity-75 text-primary">
                                                                To identify trends patterns and anomalies
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 m-auto text-end">
                                                    <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-primary svg-icon-5hx" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap bg-light-primary border-primary">
                                        <div className="card-body p-6">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="d-flex flex-column py-2">
                                                        <div className="d-flex align-items-center text-primary fs-2x fw-bold">
                                                            Web Agent
                                                        </div>
                                                        <div className="fw-bold">
                                                            <span className="fs-2 d-block mt-6 text-primary">
                                                                Web agent
                                                            </span>
                                                            <span className="opacity-75 text-primary">
                                                                Web agent
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 m-auto text-end">
                                                    <div className='fs-2hx text-primary fw-bold'>5</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap bg-light-primary border-primary">
                                        <div className="card-body p-6">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="d-flex flex-column py-2">
                                                        <div className="d-flex align-items-center text-primary fs-2x fw-bold">
                                                            Chat
                                                        </div>
                                                        <div className="fw-bold">
                                                            <span className="fs-2 d-block mt-6 text-primary">
                                                                Chat
                                                            </span>
                                                            <span className="opacity-75 text-primary">
                                                                Chat
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 m-auto text-end">
                                                    <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-primary svg-icon-5hx" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-5 mb-xl-10">
                        <div className="card-header bg-dark">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-white fs-1">Other available services</span>
                                <span className="text-white mt-1 fw-semibold fs-6">
                                    We have 2 other services which are not active for you but you can activate
                                </span>
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="row gx-9 gy-6">
                                <div className="col-xl-6">
                                    <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap bg-light-dark border-dark">
                                        <div className="card-body p-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="d-flex flex-column py-2">
                                                        <div className="d-flex align-items-center text-dark fs-2x fw-bold">
                                                            Whatsapp
                                                        </div>
                                                        <div className="fw-bold">
                                                            <span className="fs-2 d-block mt-6 text-dark">
                                                                Whatsapp
                                                            </span>
                                                            <span className="opacity-75 text-dark">
                                                                Whatsapp
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="card card-dashed h-xl-100 flex-row flex-stack flex-wrap bg-light-dark border-dark">
                                        <div className="card-body p-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="d-flex flex-column py-2">
                                                        <div className="d-flex align-items-center text-dark fs-2x fw-bold">
                                                            Call
                                                        </div>
                                                        <div className="fw-bold">
                                                            <span className="fs-2 d-block mt-6 text-dark">
                                                                Call
                                                            </span>
                                                            <span className="opacity-75 text-dark">
                                                                Call
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {BusinessSetup}